import type { ReactNode } from 'react';

enum Language {
	En = 'en',
	Es = 'es',
	It = 'it'
}

type SupportedLanguage = (typeof Language)[keyof typeof Language];

type TranslationValue = string | { [key: string]: TranslationValue };

type TranslationNamespace = {
	[key: string]: TranslationValue;
};

type TranslationDictionary = {
	[key: string]: TranslationNamespace;
};

type Params = Record<string, string | number | null>;

type TranslateFn<Namespace extends string = string> = (
	namespace: Namespace,
	key: string,
	params?: Params,
	fallback?: string
) => string;

type RichTranslateFn<Namespace extends string = string> = (
	namespace: Namespace,
	key: string,
	renderers: Record<string, (chunk: string) => ReactNode>,
	params?: Params,
	fallback?: string
) => ReactNode[];

type LocalizationInitPayload = {
	providedLang?: string | null;
	isEnabled?: boolean;
	tenant: string;
	disabledLanguages?: Language[];
	logMissingTranslations?: boolean;
};

export {
	Language,
	type SupportedLanguage,
	type TranslationDictionary,
	type TranslationNamespace,
	type TranslateFn,
	type RichTranslateFn,
	type LocalizationInitPayload
};
